import { clearCookie, getCookie, setCookie } from "../../helper";
import { ClaimAction, ClaimActionTypes, ClaimState } from "./types";

const getCleanState = (): ClaimState => ({
  id: "",
  name: "",
  status_code: "",
  customerInfo: {
    first_name: "",
    last_name: "",
    email: "",
    number: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    allowSMS: true,
  },
  purchaseInfo: {
    store_purchase: "",
    retailer_phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    invoice_number: "",
    purchase_date: "",
    invoice_image: "",
  },
  damageInfo: {
    date_incident: "",
    product_type: "",
    product_size: "",
    mattress_stained_damaged: "",
    type_of_stain_damage: "",
    protector_damage: "",
    damageNotes: "",
    damage_Protector_type: "",
    estimated_retail_value: 0,
    did_clean_product: "",
    protector_on_bed: "",
    mattress_manufacturer: "",
    mattress_model: "",
    mattress_product: "",
  },
  documents: {
    protector_damage_images: [],
    mattress_damage_images: [],
    protectall_tag_image: "",
  },
});

const initialState: ClaimState = {
  ...getCleanState(),
  ...JSON.parse(getCookie("temp-data") || "{}"),
};

export const claimReducer = (
  state: ClaimState = initialState,
  action: ClaimActionTypes
): ClaimState => {
  switch (action.type) {
    case ClaimAction.UPDTAE_CLAIM_STATE: {
      const combinedState = {
        ...state,
        ...(action?.payload || {}),
      };
      const cookieState = structuredClone(combinedState);

      delete cookieState.documents;

      if (cookieState.purchaseInfo) {
        delete cookieState.purchaseInfo.invoice_image;
      }

      setCookie("temp-data", cookieState, { parseJson: true });
      return combinedState;
    }

    case ClaimAction.CLEAN_UP: {
      clearCookie("temp-data");
      clearCookie("temp-mpp-id");
      return getCleanState();
    }

    default:
      return state;
  }
};
